import { useState, useEffect } from "react";
import { getFirestore, collection, query, where, getDocs, doc } from "firebase/firestore";
import { getAuth } from "firebase/auth";

export const useUserProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loadingProfile, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      const auth = getAuth();
      const db = getFirestore();
      const user = auth.currentUser;

      if (!user) {
        console.warn("Usuário não autenticado.");
        setLoading(false);
        return;
      }

      // Criar referência do documento users/{uid}
      const userRef = doc(db, "users", user.uid);

      // Buscar profiles com userId == referência do user
      const profilesRef = collection(db, "profiles");
      const q = query(profilesRef, where("userId", "==", userRef));
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        setProfile({ id: snapshot.docs[0].id, ...snapshot.docs[0].data() });
      } else {
        console.warn("Nenhum perfil encontrado para o usuário:", user.uid);
      }

      setLoading(false);
    };

    fetchProfile();
  }, []);

  return { profile, loadingProfile };
};
